export default "/assets/images/problem-solved-07.3a282bf69948732b.png";